baseApp.directive('datePicker', function () {
    return {
        templateUrl: '/public/directives/datePicker.html',
        scope: {
            start: '=',
            end: '=?',
            single: '@',
            options: '=?',
            dirty: '=?',
        },
        link: function ($scope, elem) {
            $scope.el = elem;
        },
        controller: ['$scope', '$timeout', 'DateRangeService', function ($scope, $timeout, DateRangeService) {
            function init() {
                var selfChange = false;
                var defaultTime;

                /*
                 * We need two flags since when changing the text both $scope.start and $Scope.end change,
                 * so getTextDate() is called twice. Each time one flag will be turned off.
                 */
                var userTextDateInput1 = false;
                var userTextDateInput2 = false;

                if ($scope.start) {
                    createCalendarComponent();
                } else {
                    selfChange = true;
                    defaultTime = moment();
                    defaultTime.hour(0);
                    defaultTime.minute(0);
                    defaultTime.second(0);
                    $scope.date = {
                        startDate: defaultTime,
                        endDate: defaultTime,
                    };
                }

                function createCalendarComponent() {
                    if ($scope.single) {
                        $scope.date = {
                            startDate: moment(parseInt($scope.start)),
                            endDate: moment(parseInt($scope.start)),
                        };
                    } else {
                        $scope.end = $scope.end || $scope.start;
                        $scope.date = {
                            startDate: moment(parseInt($scope.start)),
                            endDate: moment(parseInt($scope.end)),
                        };
                    }
                }

                function getTextDate() {
                    if (userTextDateInput1) {
                        userTextDateInput1 = false;
                        return;
                    }
                    if (userTextDateInput2) {
                        userTextDateInput2 = false;
                        return;
                    }
                    if ($scope.single) {
                        $scope.textdate = $scope.date.startDate.format('L');
                        return;
                    }
                    $scope.textdate = DateRangeService.getDateText($scope.start, $scope.end);

                    if ($scope.end < $scope.start) {
                        $scope.textdate = 'Realtime';
                        return;
                    }

                    if ($scope.textdate) {
                        return;
                    }
                    $scope.textdate = $scope.date.startDate.format('L') + ' - ' + $scope.date.endDate.format('L');
                }

                if ($scope.single) {
                    $scope.opts = {
                        singleDatePicker: true,
                        showDropdowns: true,
                        maxDate: ($scope.options && $scope.options.maxDate)? $scope.options.maxDate : null,
                        minDate: ($scope.options && $scope.options.minDate)? $scope.options.minDate : null,
                    };
                } else {
                    $scope.opts = {
                        startDate: moment(parseInt($scope.start)),
                        endDate: moment(parseInt($scope.end)),
                        opens: 'left',
                        showDropdowns: true,
                        ranges: {
                            'Last Hour': [moment().subtract(1, 'hours'), moment()],
                            'Last Day': [moment().subtract(1, 'days'), moment()],
                            'Last 7 Days': [moment().subtract(7, 'days'), moment()],
                            'Last 30 Days': [moment().subtract(30, 'days'), moment()],
                        },
                        maxDate: ($scope.options && $scope.options.maxDate)? $scope.options.maxDate : null,
                        minDate: ($scope.options && $scope.options.minDate)? $scope.options.minDate : null,
                    };
                }

                /*
                 * Dates prior to 1/1/1970 will not be accepted
                 */
                $scope.$watch('date', function (newDate, oldDate) {
                    if (newDate && !_.isEqual(newDate, oldDate) && newDate.startDate.toDate().getTime() >= 0) {
                        $scope.start = newDate.startDate.toDate().getTime();
                        $scope.end = newDate.endDate.toDate().getTime();
                        if (!selfChange && $scope.dirty) {
                            $scope.dirty.changed = new Date().getTime();
                        }
                        selfChange = false;
                    }
                }, true);

                /*
                 * Dates prior to 1/1/1970 will not be accepted
                 */
                $scope.$watch('textdate', function(newDate, oldDate) {
                    if (newDate && !_.isEqual(newDate, oldDate)) {
                        if (newDate.indexOf('Last') == 0) {
                            $scope.end = "now";
                            $scope.start = DateRangeService.getRangeFromText(newDate);
                        }
                        else {
                            let splittedNewDate = newDate.split(/\D/);
                            let date = new Date(splittedNewDate[2], splittedNewDate[0] - 1, splittedNewDate[1], 23, 59, 59);
                            if (isNaN(date.getTime()) || date.getTime() < 0) {
                                return;
                            }
                            if($scope.options && $scope.options.minDate && $scope.options.minDate.getTime() > date.getTime()) {
                                date = new Date($scope.options.minDate);
                                date.setHours(23, 59, 59);
                            }
                            if($scope.options && $scope.options.maxDate && $scope.options.maxDate.getTime() < date.getTime()) {
                                date = new Date($scope.options.maxDate);
                                date.setHours(23, 59, 59);
                            }
                            userTextDateInput1 = true;
                            userTextDateInput2 = true;
                            $scope.start = date.getTime();
                            $scope.end = date.getTime() + 999;
                        }

                        if (!selfChange && $scope.dirty) {
                            $scope.dirty.changed = new Date().getTime();
                        }
                        selfChange = false;
                        createCalendarComponent();
                    }
                }, true);

                $scope.$watch('start', function (newVal, oldVal) {
                    if (newVal && !_.isEqual(newVal, oldVal)) {
                        getTextDate();
                    }
                }, true);

                $scope.$watch('end', function (newVal, oldVal) {
                    if (newVal && !_.isEqual(newVal, oldVal)) {
                        getTextDate();
                    }
                }, true);

                //timeout is here to avoid digest inside digest.
                $scope.open = function () {
                   $timeout(function() {
                        $($scope.el).find('.date-picker').click();
                    }, 0, false);
                };

                if ($scope.options) {
                    $scope.$watch('options.reload', function () {
                        if ($scope.options.reload) {
                            $scope.options.reload = false;
                            init();
                        }
                    });
                }

                getTextDate();
            }

            init();
        }],
    };
});
